import { RaThemeOptions } from 'react-admin';

import { isBoExternal } from '@sh4res/bo-common/utils/env';

const AXA_PRIMARY_COLOR = '#00008F';
const AXA_PRIMARY_COLOR_8 = '#00008F14';

export const axaThemeCustomizations: RaThemeOptions = {
  palette: {
    primary: {
      main: AXA_PRIMARY_COLOR,
    },
    secondary: {
      main: AXA_PRIMARY_COLOR,
    },
    info: {
      main: AXA_PRIMARY_COLOR,
    },
    text: {
      secondary: '#444444',
    },
  },
  components: {
    RaSidebar: {
      styleOverrides: {
        root: {
          backgroundColor: 'white',
          '& p': {
            color: 'black',
          },
          '& .MuiPaper-root': {
            boxShadow: 'none',
          },
        },
      },
    },
    RaSidebarToggleButton: {
      styleOverrides: {
        root: {
          color: '#000000',
          marginTop: '10px',
        },
      },
    },
    RaMenuRoot: {
      styleOverrides: {
        root: {
          paddingTop: isBoExternal() ? '20px' : '0px',
        },
      },
    },
    RaMenuItem: {
      styleOverrides: {
        root: {
          color: '#000000',
          padding: 'unset',
          marginLeft: '8px',
          marginRight: '8px',
          '& .RaMenuItem-active': {
            marginLeft: 'unset',
            paddingLeft: 'unset',
            color: AXA_PRIMARY_COLOR,
            backgroundColor: AXA_PRIMARY_COLOR_8,
            borderRadius: 'unset',
            borderLeft: `2px solid ${AXA_PRIMARY_COLOR}`,
            '& span': {
              fontWeight: 700,
            },
          },
          '& .RaMenuItem-link': {
            paddingLeft: '8px',
          },
        },
      },
    },
    RaBreadcrumbItem: {
      styleOverrides: {
        root: {
          color: 'rgba(0, 0, 0, 0.87) !important',
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          width: 'unset',
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-root': {
            color: AXA_PRIMARY_COLOR,
          },
          '& .MuiPaginationItem-root': {
            color: AXA_PRIMARY_COLOR,
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            color: 'rgba(0, 0, 0, 0.76)',
          },
        },
        contained: {
          '&:hover': {
            boxShadow: '0 8px 20px rgba(0, 0, 0, 0.4), 0 4px 10px rgba(0, 0, 0, 0.3)',
          },
        },
        disableElevation: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        textColorPrimary: {
          color: '#000000 !important',
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          '& .Mui-selected': {
            color: `${AXA_PRIMARY_COLOR} !important`,
            backgroundColor: AXA_PRIMARY_COLOR_8,
            fontWeight: 700,
          },
        },
        vertical: {
          borderLeft: '2px solid transparent',
          '& .Mui-selected': {
            borderLeft: `2px solid ${AXA_PRIMARY_COLOR}`,
          },
        },
      },
    },
    MuiStepLabel: {
      styleOverrides: {
        label: {
          '&.Mui-completed': {
            color: '#2E7D32',
          },
          '&.Mui-active': {
            color: AXA_PRIMARY_COLOR,
            fontWeight: 600,
          },
        },
      },
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          '&.Mui-active': {
            color: AXA_PRIMARY_COLOR,
          },
          '&.Mui-completed': {
            color: '#2E7D32',
          },
        },
      },
    },
  },
};
